import { AnchorPointPopupInfo } from '../../../../../mapComponents/Popups';

const AnchorPointPopup = ({
  anchorPointInfo,
  theme,
  showNotification,
  refreshData,
  scenarioID
}) => {
  return (
    <AnchorPointPopupInfo
      data={{
        anchorPointName: anchorPointInfo.displayCustomerName,
        ...anchorPointInfo
      }}
      theme={theme}
      scenarioID={scenarioID}
      showNotification={showNotification}
      refreshData={refreshData}
      markerColor={theme.AnchorBGColor}
      markerBorderColor={theme.routeMapColorPalette.MarkerBorderColor}
      markerStrokeColor={theme.AnchorTextColor}
    />
  );
};

export default AnchorPointPopup;
